import { Card, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

const NoData: React.FC<{ title?: string }> = ({ title }) => {
    const { t } = useTranslation(['common']);
    return (
        <Card
            sx={{
                px: 3,
                py: 3,
                borderRadius: 2,
            }}
        >
            <Box
                sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2,
                }}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="250px"
                width="100%"
            >
                <img src="/static/icons/ci_no_data.svg" alt="" />
                <Typography color="text.secondary" variant="h6">
                    {title ? <>{title}</> : t('no.data')}
                </Typography>
            </Box>
        </Card>
    )
};

export default NoData;
